import React, { useState, useEffect } from 'react'
import TimelineView from 'pages/logged_in/shared/timeline/Timeline.view'
import { useParams } from 'react-router-dom'
import { useItem } from 'logic/item/item.hook'
import { useWorkflow } from 'logic/workflow/workflow.hook'
import _ from 'lodash'

function TimelineLogic(props) {
	let { id } = useParams()
	const { item } = useItem(id)
	const workflow = useWorkflow()

	const [infoFields, setInfoFields] = useState([])

	useEffect(() => {
		if (workflow && item) {
			const itemSteps = _(item.steps)
				.values()
				.map('fields')
				.flattenDeep()
				.value()

			const listFields = _(workflow.steps)
				.map(step => _.filter(step.fields, { list: true }))
				.flattenDeep()
				.value()

			const infoFields = _.map(listFields, ({ id, label }) => {
				const itemField = _.find(itemSteps, { id })
				if (itemField) return {
					label,
					value: itemField.value
				}
			})

			setInfoFields(_.compact(infoFields))
		}

	}, [workflow, item])

	return (
		<TimelineView
			infoFields={infoFields}
			workflow={workflow}
			item={item}
			loading={_.isNull(item)}
			authorized={true}
		/>
	)
}

export default TimelineLogic
